import {
  Dialog,
  Box
} from '@mui/material';
import { CustomButton } from '../../../v2/MUI_custom_component';
import IllustrationWrapper from '../../../v3/Illustrration/IllustrationWrapper';

const HumbeeModal = ({
  open,
  onClose,
  onConfirm,
  loading,
  illustration,
  title = "Are you sure you want to exit?",
  subtitle = "This action cannot be undone. All data would be lost?",
  confirmLabel = "Yes",
  cancelLabel = "No",
  width = { xs: 'auto', md: 600 },
  buttonSx = { width: { xs: '100%', md: '100%' } },
  sx = {}
}) => {
  const handleCancelClick = () => {
    onClose();
  };

  const handleDeleteClick = () => {
    onConfirm();
  };
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      PaperProps={{
          sx: { borderRadius: 2, textAlign: 'center', width, p: 2, m: {xs: 2, md: 0}, gap: 4, ...sx}
      }}
    >
      <Box sx={{ textAlign: 'center'}}>
          <IllustrationWrapper
            illustration={illustration}
            title={title}
            subtitle={subtitle}
          />
      </Box>
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', }}>
          <CustomButton
            variant="outlined"
            color="primary"
            label={cancelLabel}
            onClick={handleCancelClick}
            size="medium"
            sx={buttonSx}
          />
          {confirmLabel &&
            <CustomButton
              variant="filled" 
              color="primary"
              label={confirmLabel}
              onClick={handleDeleteClick}
              disabled={loading}
              loading={loading}
              size="medium"
              sx={buttonSx}
            />
          }
      </Box>
    </Dialog>
  );
};

export default HumbeeModal;
